// extracted by mini-css-extract-plugin
export default {"AuthView":"AuthView_AuthView__mx18M","Logo":"AuthView_Logo__x+j96","Main":"AuthView_Main__GZeYP"};